<template>
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title"> {{$t('progess_report_wo')}}</div>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">

                                    <div class="grid mb-2 filter-row">
                                        <div class="col-2 filter-label">
                                            <label>{{$t('generate_date_wo')}}</label>
                                        </div>
                                        <div class="col-10 filter-input">
                                            <div class="grid">
                                                <div class="col-6">
                                                    <FormField fieldName="From_Date" v-model="header"
                                                        fieldClass="col-6" labelClass="col-4">
                                                        <DatePicker v-if="header" v-model="header.From_Date" :placeholder="$t('from_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" />
                                                    </FormField>
                                                </div>
                                            <div class="col-6">
                                                <FormField fieldName="To_Date" v-model="header"
                                                    fieldClass="col-6" labelClass="col-4">
                                                    <DatePicker v-if="header" v-model="header.To_Date" :placeholder="$t('to_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" />
                                                </FormField>
                                            </div>
                                            </div>
                                        </div>
                                    </div>

                    <!-- <div class="grid">
                        <div class="col-6">
                            <FormField fieldName="From_Date" :labelName="$t('from_date')" v-model="header"
                                fieldClass="col-6" labelClass="col-4">
                                <DatePicker v-if="header" v-model="header.From_Date" :placeholder="$t('from_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" />
                            </FormField>
                        </div>
                        <div class="col-6">
                            <FormField fieldName="To_Date" :labelName="$t('to_date')" v-model="header"
                                fieldClass="col-6" labelClass="col-4">
                                <DatePicker v-if="header" v-model="header.To_Date" :placeholder="$t('to_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" />
                            </FormField>
                        </div>
                    </div> -->
                </div>
                <Button type="button" label="Generate" @click="getReport()" />
                &nbsp;
                <Button type="button" class="p-button-success" label="Reopen" @click="reopenTab()"
                    v-show="this.reportTbl" />
            </template>
        </Card>
    <ShowReport :isVisible="showReport" :reportTbl="this.reportTbl" @close="resetBtn()" />
</template>

<script type="text/javascript">
import ShowReport from "../Report/ShowReport.vue";
import FormField from "../Helper/FormField.vue";
export default {
    components: {
        ShowReport,
        FormField,
    },
    data() {
        return {
            test: 0,
            mode: "",
            dataUrl: "Report/progressreportwo",
            reportTbl: null,
            showReport: false,
            loadingReport: false,
            mergedOptions: [
                { label: "Y", value: 1 },
                { label: "N", value: 0 },
            ],
            header: {
                From_Date: null,
                To_Date: null,
            },
             submitted :false
        };
    },
    methods: {
        reopenTab() {
            this.showReport = true;
        },
        resetBtn() {
            this.showReport = false;
        },
        tableToExcel() {
            this.loadingReport = !this.loadingReport;
        },
        getReport() {
            this.$emit('block-ui');
            this.$axios.post(this.$API_URL + this.dataUrl, this.header)
                .then((response) => {
                    this.reportTbl = {
                        header: response.data.data.header,
                        content: response.data.data.content,
                        title: response.data.data.title,
                    };
                    this.showReport = true;
                    this.$emit('unblock-ui');
                })
                .catch(() => {
                    this.$emit('unblock-ui');
                });
        },
        showError() {
            this.loadingReport = !this.loadingReport;
        },
        closeReport() {
            this.showReport = false;
        },
    },
    mounted() { },
     computed : {
           years() {
            let years = [];
            for (var i = 2022; i <= new Date().getFullYear(); i++) {
                years.push({ value: i.toString() })
            }
            return years;
        },
    }
};
</script>
